import React from "react";
import "./style.scss";
import { useLocation } from "react-router-dom";
import { findPathName } from "views/utils/handlePath";

export const PageLocation = () => {
  const location = useLocation();
  return (
    <span className="pageLocation">{findPathName(location.pathname)}</span>
  );
};

export const PageLocationSP = () => {
  const location = useLocation();
  return (
    <span className="pageLocationSP">{findPathName(location.pathname)}</span>
  );
};
